import { z } from "zod";

const CRITICALITY_LABEL_KEYS = ["LOW", "MEDIUM", "HIGH", "CRITICAL"] as const;
const CriticalityLabelKeySchema = z.enum(CRITICALITY_LABEL_KEYS);

const CLASSIFICATION_PROPERTY_KEYS = ["CONFIDENTIALITY", "INTEGRITY", "AVAILABILITY"] as const;
export const ClassificationPropertyKeySchema = z.enum(CLASSIFICATION_PROPERTY_KEYS);
export type ClassificationPropertyKey = z.infer<typeof ClassificationPropertyKeySchema>;

export const LevelSchema = z.literal([0, 1, 2, 3, 4]);
export type Level = z.infer<typeof LevelSchema>;

export const ScoreSchema = z.object({
  propertyKey: ClassificationPropertyKeySchema,
  value: LevelSchema,
});
export type Score = z.infer<typeof ScoreSchema>;

export const CriticalitySchema = z.object({
  value: z.number().int(),
  labelKey: CriticalityLabelKeySchema,
});
export type Criticality = z.infer<typeof CriticalitySchema>;
